import { useState } from 'react';

import FilterAltIcon from '@mui/icons-material/FilterAlt';

import { mapFilterConfigurationToLoanFilter } from '../../../../../../pages/LoanListCreateEditForm/utils/mapFilterConfigurationToLoanFilter';
import useFiltersConfiguration from '../../../../../../services/queries/useFiltersConfiguration';
import { FiltersEngine } from '../../../../../Filters';
import { Button, FiltersActionsContainer } from '../../../../../index';

interface FiltersProps {
  isLoading: boolean;
  onSubmit: (data: Record<string, unknown>) => void;
}

function Filters({ isLoading, onSubmit }: FiltersProps) {
  const [isExpanded, setIsExpanded] = useState(false);

  const { data, isFetched } = useFiltersConfiguration();

  const filterNames = ['requestedDate', 'loanStatuses'];

  const filters = isFetched
    ? data?.groupFilters.filter((item) => filterNames.includes(item.name)).map(mapFilterConfigurationToLoanFilter)
    : [];

  const onExpandFiltersClick = () => setIsExpanded((prevIsExpanded) => !prevIsExpanded);

  return (
    <>
      <FiltersActionsContainer>
        <Button color="secondary" disabled={isLoading} startIcon={<FilterAltIcon />} onClick={onExpandFiltersClick}>
          Filters
        </Button>
      </FiltersActionsContainer>
      <FiltersEngine onSubmit={onSubmit} filters={filters!} expanded={isExpanded} />
    </>
  );
}

export default Filters;
